<template>
        <div class="outer-wrapper">
            <!--<img class='backImg' :src="imgUrl" alt='' />-->
            <div class='wrap'>
                <div class="med-wrapper">
                    <div class='title'>
                        <p class="title-right title-text">欢迎登录数据中心！</p>
                        <p class="title-left title-text" @click="toHome">返回主页</p>
                        <div class="arrow" @click="toHome"></div>
                    </div>
                    <div class="login-logo">
                    <img class='login-logo-img' :src="logoImgUrl" alt='' />
                    </div>
                    <div class='main'>
                        <div class='main-input'>
                            <el-input @focus="handleRewrite" class='m-i' placeholder="账号/手机号/邮箱" v-model="values.account"
                                clearable><i slot="suffix" class=""></i></el-input>
                            <el-input type="password" @focus="handleRewrite" class='m-i' placeholder="请输入登录密码" v-model="values.password"
                                clearable><i slot="suffix" class=""></i></el-input>
                            <div class='error-box m-i' v-show="errorFlag.isCode"><span><i class=""></i></span><span
                                    class="error-text">{{errorFlag.text}}</span></div>
                            <el-button class='m-i m-bt' type="primary" plain @click="toLogin">登录</el-button>
                        </div>
                        <div class='footer'>
                            <span class="f-text bottom-right">
                                <router-link :to="{name:'register'}">免费注册</router-link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>
<script>

    export default {
        name: "systemLogin",
        components: {
        },
        data() {
            return {
                values: {
                    account: "",
                    password: "",
                },
                errorFlag: {
                    isCode: false,
                    text: ""
                },
                imgUrl: process.env.BASE_URL + "img/login_bg.jpg",
                logoImgUrl: process.env.BASE_URL + "img/login_logo.png",
                index_url:"/index",

            }
        },
        props: {
        },
        created() {
        },
        mounted() {
        },
        methods: {
            //非空验证
            handleRewrite() {
                this.errorFlag.isCode = false;
            },
            checkVal() {
                if (this.values.account == "") {
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "用户名不能为空";
                } else if (this.values.password == "") {
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "密码不能为空";
                }
            },
            toHome(){
                location.href = this.index_url;
            },

            toLogin() {
                this.checkVal();
                this.$axios.post(this.$url + '/login', {
                    val: this.values
                }).then(response => {
                    if (response.data.error_info !== '') {
                        this.errorFlag.isCode = true;
                        this.errorFlag.text = response.data.error_info;
                    } else {
                        localStorage.setItem(
                          "current_user_token",
                          response.data.user_token
                        );
                        let resAuthData = {
                                barRights:response.data.barRights,
                                sfileRight:response.data.sfileRight,
                                expireTime:Date.now()+1000*3600*4,
                            };
                        localStorage.setItem('authData',JSON.stringify(resAuthData));
                        location.href = this.index_url;
                    }

                }).catch(error => {
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = error;
                })
            },
        }
    }
</script>


<style scoped>
    .outer-wrapper{
        width:100%;
        background-image: url("~@/assets/login_bg.jpg");   
        background-attachment:scroll;
        overflow: hidden;
        background-repeat: no-repeat;
    }
    .backImg {
        width: 100%;
        max-width: 100%;
    }

    .wrap {
        position: relative;
        width: 500px;
        background: #fff;
        border-radius: 5px;
        text-align: center;
        left:50%;
        margin:9% 0 15% 0;
        padding-bottom: 100px;
    }

    .main {
        margin:0 auto;
        width: 300px;
        text-align: center;
    }

    .title {
        height: 36px;
        background-color: #993333;
        position: relative;
    }

    .login-logo{
        padding: 50px 0;

    }

    .login-logo-img{
        width:200px;

    }

    .title-text {
        font-size: 12px;
        color:#ddd;
        line-height: 40px;
        position: absolute;
    }

    .title-right{
        right:24px;
    }

    .title-left{
        left:24px;
        cursor: pointer;
    }

    .m-i {
        margin-top: 20px;
    }

    .m-bt {
        width: 100%;
        background-color: #993333;
        color:#ddd;
        border:none;
    }

    .m-bt:hover{
        background-color: #993333;
        border:none;
        color:#fff;
    }

    .error-box {
        color: red;
        font-size: 12px;
        text-align: left;
        margin-left: 2px;
    }

    .footer {
        text-align: right;
        height: 40px;
        line-height: 50px;
    }

    .f-text {
        color: #999;
        font-size: 14px;
    }

    .img-wrapper {
        position: absolute;
        top: 0;
    }

    .loginImg {
        height: 360px;
        border-radius: 5px;
    }

    .arrow{
        position: absolute;
        cursor: pointer;
        left:10px;
        top:14px;
        width:10px;
        height: 10px;
        background: url('~@/assets/more1.png');
        background-size: 100% 100%;
    }
    
</style>